import styled from '@emotion/styled';
import type { WidgetTableModel } from '../../utils/widget-chart';

type Props = { model: WidgetTableModel };

export function WidgetDataTable({ model }: Props) {
  if (model.rows.length === 0) {
    return <div>No table data available</div>;
  }
  return (
    <TableContainer>
      <Table>
        <thead>
          <TableRow>
            {model.headers.map((header, index) => (
              <TableHeaderCell key={index}>{header}</TableHeaderCell>
            ))}
          </TableRow>
        </thead>
        <tbody>
          {model.rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell key={cellIndex}>{String(cell)}</TableCell>
              ))}
            </TableRow>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
}

WidgetDataTable.displayName = 'Chat.Attachments.WidgetDataTable';

const TableContainer = styled.div(({ theme }) => ({
  width: '100%',
  maxHeight: 400,
  overflowY: 'auto',
  border: `1px solid ${theme?.palette?.gray?.light1 || '#e0e0e0'}`,
  borderRadius: 6,
  backgroundColor: theme?.palette?.white?.main || '#fff',
  marginBottom: 12,
}));
const Table = styled.table({ width: '100%', borderCollapse: 'collapse' });
const TableRow = styled.tr(({ theme }) => ({
  '&:nth-of-type(even)': { backgroundColor: theme?.palette?.gray?.light3 || '#fafafa' },
}));
const TableHeaderCell = styled.th(({ theme }) => ({
  padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 14,
  color: theme?.palette?.gray?.dark1 || '#333',
  borderBottom: `2px solid ${theme?.palette?.gray?.light1 || '#e0e0e0'}`,
}));
const TableCell = styled.td(({ theme }) => ({
  padding: '12px 16px', fontSize: 14, color: theme?.palette?.gray?.dark1 || '#333',
  borderBottom: `1px solid ${theme?.palette?.gray?.light2 || '#f0f0f0'}`,
}));
